module.exports = __webpack_public_path__ + "static/media/transition.33696517.mp3";